(function() {
  'use strict';

  var navContainer = document.querySelector('.faq-navigation');
  if (!navContainer) return;

  var navButtonsWrapper = navContainer.querySelector('.faq-navigation__buttons');
  var navButtons = navContainer.querySelectorAll('.faq-navigation__button');
  var sections = [];
  var isInitialized = false;
  var originalOffsetTop = 0;
  var placeholderEl = null;
  var currentActiveButton = null;

  function init() {
    if (isInitialized) return;
    isInitialized = true;

    // Store original position
    originalOffsetTop = navContainer.offsetTop;

    // Create placeholder to prevent content jump when nav becomes fixed
    placeholderEl = document.createElement('div');
    placeholderEl.className = 'faq-navigation-placeholder';
    placeholderEl.style.display = 'none';
    placeholderEl.style.height = navContainer.offsetHeight + 'px';
    navContainer.parentNode.insertBefore(placeholderEl, navContainer.nextSibling);

    // Collect all target sections
    navButtons.forEach(function(button) {
      var targetId = button.getAttribute('data-target');
      var targetElement = document.getElementById(targetId);
      if (targetElement) {
        sections.push({ id: targetId, element: targetElement, button: button });
      }
    });

    // Click handler for smooth scroll
    navButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        var targetId = this.getAttribute('data-target');
        var targetElement = document.getElementById(targetId);

        if (targetElement) {
          var navHeight = navContainer.offsetHeight;
          var headerVisible = isHeaderVisible();
          var headerHeight = headerVisible ? getHeaderHeight() : 0;
          var totalOffset = headerHeight + navHeight + 20;
          var elementPosition = targetElement.getBoundingClientRect().top;
          var offsetPosition = elementPosition + window.pageYOffset - totalOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });

    // Start scroll listener
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          updateStickyState();
          updateActiveSection();
          ticking = false;
        });
        ticking = true;
      }
    });

    // Handle resize
    window.addEventListener('resize', function() {
      if (!navContainer.classList.contains('is-fixed')) {
        originalOffsetTop = navContainer.offsetTop;
      }
      placeholderEl.style.height = navContainer.offsetHeight + 'px';
    });

    // Initial update
    updateStickyState();
    updateActiveSection();
  }

  function getHeaderHeight() {
    var header = document.querySelector('#SiteHeader');
    if (header) {
      return header.offsetHeight;
    }
    return 0;
  }

  function isHeaderVisible() {
    var header = document.querySelector('#SiteHeader');
    if (!header) return false;
    return !header.classList.contains('header-hidden');
  }

  function updateStickyState() {
    var header = document.querySelector('#SiteHeader');
    var headerHeight = header ? header.offsetHeight : 0;
    var isHeaderHidden = header ? header.classList.contains('header-hidden') : true;
    var scrollY = window.pageYOffset;

    // Determine if nav should be fixed
    var triggerPoint = originalOffsetTop - headerHeight;
    var shouldBeFixed = scrollY > triggerPoint;

    if (shouldBeFixed && !navContainer.classList.contains('is-fixed')) {
      navContainer.classList.add('is-fixed');
      placeholderEl.style.display = 'block';
    } else if (!shouldBeFixed && navContainer.classList.contains('is-fixed')) {
      navContainer.classList.remove('is-fixed');
      placeholderEl.style.display = 'none';
    }

    // Update top position based on header visibility
    if (navContainer.classList.contains('is-fixed')) {
      if (isHeaderHidden) {
        navContainer.style.top = '0px';
      } else {
        navContainer.style.top = headerHeight + 'px';
      }
    } else {
      navContainer.style.top = '';
    }
  }

  function updateActiveSection() {
    if (sections.length === 0) return;

    var navHeight = navContainer.offsetHeight;
    var headerHeight = isHeaderVisible() ? getHeaderHeight() : 0;
    var scrollPosition = window.pageYOffset + headerHeight + navHeight + 50;

    var activeSection = null;

    for (var i = 0; i < sections.length; i++) {
      var current = sections[i];
      var currentTop = current.element.getBoundingClientRect().top + window.pageYOffset;
      var next = sections[i + 1];
      var nextTop = next
        ? next.element.getBoundingClientRect().top + window.pageYOffset
        : document.body.scrollHeight;

      if (scrollPosition >= currentTop && scrollPosition < nextTop) {
        activeSection = current;
        break;
      }
    }

    // If scrolled above all sections, fall back to first so nav scrolls back
    if (!activeSection) {
      activeSection = sections[0];
    }

    // Update active states
    navButtons.forEach(function(btn) {
      btn.classList.remove('is-active');
    });

    activeSection.button.classList.add('is-active');

    // When active button changes, snap it to the leftmost visible position
    if (activeSection.button !== currentActiveButton) {
      currentActiveButton = activeSection.button;

      // getBoundingClientRect gives position relative to viewport,
      // so we adjust by container's left + current scrollLeft to get
      // the button's true position within the scrollable content
      var buttonRect = activeSection.button.getBoundingClientRect();
      var containerRect = navButtonsWrapper.getBoundingClientRect();
      var buttonPosInScroll = buttonRect.left - containerRect.left + navButtonsWrapper.scrollLeft;

      navButtonsWrapper.scrollTo({
        left: Math.max(0, buttonPosInScroll - 20),
        behavior: 'smooth'
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
